import React from 'react';
import PropTypes from 'prop-types';
import Item from './Item';
import { DropdownContainer } from './style';
export var DropdownItem = function DropdownItem(props) {
  var show = props.dropdownState[props._id] ? props.dropdownState[props._id].show : false;
  var items = props.items;
  return React.createElement(DropdownContainer, {
    key: props._id,
    tab: props.tab
  }, React.createElement(Item, {
    header: true,
    width: '60%',
    left: '10%',
    active: show,
    key: props._id,
    _id: props._id,
    tag: props.tag,
    color: props.color,
    checkboxState: props.checkboxState,
    toggleShowList: function toggleShowList() {
      return props.toggleShowList(props._id);
    },
    toggleCheckbox: props.toggleCheckbox
  }), show ? items.map(function (a) {
    return React.createElement(Item, {
      width: '55%',
      left: '20%',
      _id: a._id,
      tag: a.tag,
      key: a._id,
      color: a.color,
      active: props.active,
      checkboxState: props.checkboxState,
      toggleCheckbox: props.toggleCheckbox
    });
  }) : '');
};
DropdownItem.propTypes = {
  toggleCheckboxList: PropTypes.func,
  active: PropTypes.bool.isRequired,
  dropdownState: PropTypes.object,
  checkboxState: PropTypes.object,
  toggleShowPlot: PropTypes.func,
  toggleShowList: PropTypes.func,
  toggleCheckbox: PropTypes.func,
  actions: PropTypes.object,
  color: PropTypes.string,
  tag: PropTypes.string,
  title: PropTypes.string,
  items: PropTypes.array,
  header: PropTypes.bool,
  _id: PropTypes.string,
  tab: PropTypes.bool
};